import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/**
 * Persisted view-mode preference for the Employees list (CLAUDE.md §2.3),
 * mirroring the CRM list stores. Search/status filters live in URL-bound page
 * state and stay out of the store — those are server-driven query params, not
 * durable user prefs.
 */
export type EmployeesViewMode = 'table' | 'list' | 'cards' | 'grouped' | 'grouped_dept';

export const EMPLOYEES_VIEW_MODES: EmployeesViewMode[] = [
  'table',
  'list',
  'cards',
  'grouped',
  'grouped_dept',
];

interface EmployeesUiState {
  view: EmployeesViewMode;
  setView: (view: EmployeesViewMode) => void;
  /** Current DRF `OrderingFilter` value (e.g. `-hire_date`). Session-only. */
  ordering: string | undefined;
  setOrdering: (ordering: string | undefined) => void;
}

export const useEmployeesUi = create<EmployeesUiState>()(
  persist(
    (set) => ({
      view: 'table',
      setView: (view) => set({ view }),
      ordering: undefined,
      setOrdering: (ordering) => set({ ordering }),
    }),
    {
      name: 'hrm.employees:ui',
      // Only the view mode is durable — ordering stays ephemeral so refreshes
      // return to a clean default.
      partialize: (state) => ({ view: state.view }),
    },
  ),
);
